import { createReducer } from '@reduxjs/toolkit';
import { clearPreoffersItemsAction } from './preoffers.action';
import { preloadedPreoffersState } from './preoffers.preloaded-state';
import { searchAllPreoffersThunk } from './preoffers.thunk';
import { getArrayIds, transformArrayToObject } from '@innowise-group/utilities';
import { logoutAction } from '../common';

export const preoffersReducer = createReducer(preloadedPreoffersState, (builder) =>
  builder
    .addCase(clearPreoffersItemsAction, (state) => {
      state.preoffers = preloadedPreoffersState.preoffers;
    })
    .addCase(searchAllPreoffersThunk.fulfilled, (state, { payload }) => {
      state.preoffers.items = transformArrayToObject(payload.content);
      state.preoffers.ids = getArrayIds(payload.content);
      state.preoffers.isLoading = false;
      state.preoffers.totalElements = payload.totalElements;
      state.preoffers.totalPages = payload.totalPages;
    })
    .addCase(searchAllPreoffersThunk.pending, (state) => {
      state.preoffers.isLoading = true;
    })
    .addCase(searchAllPreoffersThunk.rejected, (state) => {
      state.preoffers = preloadedPreoffersState.preoffers;
    })
    .addCase(logoutAction, () => preloadedPreoffersState),
);
